<template>
  <div class="history-review-container">
    <template v-if="isInitialized">
      <MCard title="历史回溯" title-align="center" v-if="page === 'options'">
        <div class="review-options">
          <div class="review-options-item" v-for="item in [menuList[0]]" :key="item.id">
            <span class="review-options-item_title">{{ item.name }}</span>
            <div>
              <MForm v-bind="form" :options="item.options" />
            </div>
          </div>
          <div class="handle-button">
            <ElButton type="primary" @click="page = 'monitor'">查询</ElButton>
          </div>

          <div class="review-options-item" v-for="item in menuList.slice(1)" :key="item.id">
            <span class="review-options-item_title">{{ item.name }}</span>
            <div class="review-options-item_content">
              <MForm v-bind="form" :options="item.options" />
            </div>
          </div>
        </div>
      </MCard>

      <Monitor v-else mode="review" />
    </template>
  </div>
</template>

<script>
import Monitor from '../situation/index.vue';
import MForm from '@/components/form/v2.vue';
import MCard from '@/components/mCard/index.vue';

export default {
  components: { Monitor, MForm, MCard },
  inject: [
    'pathogenList',
    'model',
    'nodeList',
    'nodeRunStateList',
    'nodeListStateGroup',
    'timeRangeDict',
    'nodeSceneTypeList',
    'nodeSceneTypeGroup',
    'isInitializedGetter',
    'selectAll'
  ],
  data() {
    return {
      page: 'options',
      form: {
        config: {},
        model: this.model,
        dataSource: {
          nodeList: this.nodeList,
          pathogenList: this.pathogenList
        }
      },
      menuList: [
        {
          id: 'timeRange',
          name: '时间范围',
          icon: 'icon-clock',
          show: () => false,
          // show: () => this.mode === 'review',
          contentStyle: {
            overflow: 'unset'
          },
          subPanelStyle: {
            '--sub-panel-width': '450px',
            '--sub-panel-height': '30%'
          },
          options: [
            {
              prop: 'timeRange',
              type: 'datePicker',
              componentAttrs: {
                style: 'width: 380px'
              },
              componentProps: {
                appendToBody: false,
                type: 'monthrange',
                rangeSeparator: '-',
                startPlaceholder: '开始时间',
                endPlaceholder: '结束时间',
                valueFormat: 'timestamp'
              }
            }
          ]
        },
        {
          id: 'region',
          name: '节点分类',
          show: () => this.mode !== 'review',
          icon: 'icon-pie',
          subPanelStyle: {},
          options: [
            {
              prop: 'nodeSceneTypeCheckAll',
              type: 'checkbox',
              on: {
                change: v => {
                  if (v) {
                    this.form.model.nodeSceneTypeList.splice(
                      0,
                      Infinity,
                      ...this.nodeSceneTypeList.map(e => e.value)
                    );
                  } else {
                    this.form.model.nodeSceneTypeList.splice(0, Infinity);
                  }
                }
              },
              componentProps: {
                label: '全选',
                indeterminate: ({ nodeSceneTypeList }) => {
                  return (
                    nodeSceneTypeList.length > 0 &&
                    nodeSceneTypeList.length < this.nodeSceneTypeList.length
                  );
                }
              }
            },
            {
              prop: 'nodeSceneTypeList',
              type: 'checkboxGroup',
              componentProps: {
                options: this.nodeSceneTypeList.map(e => ({
                  ...e,
                  indeterminate: ({ value }, { nodeList }) => {
                    const list = this.nodeSceneTypeGroup[value].items;

                    const len = list.filter(e => nodeList.includes(e.id)).length;

                    return len > 0 && len < list.length;
                  }
                }))
              }
            }
          ]
        },
        {
          id: 'nodeStatus',
          name: '节点状态',
          show: () => this.mode !== 'review',
          icon: 'icon-node-state',
          subPanelStyle: {
            '--sub-panel-height': '60%'
          },
          options: [
            {
              prop: 'nodeStateCheckAll',
              type: 'checkbox',
              on: {
                change: v => {
                  if (v) {
                    this.form.model.nodeRunStateList.splice(
                      0,
                      Infinity,
                      ...this.nodeRunStateList.map(e => e.state)
                    );
                  } else {
                    this.form.model.nodeRunStateList.splice(0, Infinity);
                  }
                }
              },
              componentProps: {
                label: '全选',
                indeterminate: ({ nodeRunStateList }) => {
                  return (
                    nodeRunStateList.length > 0 &&
                    nodeRunStateList.length < this.nodeRunStateList.length
                  );
                }
              }
            },
            {
              prop: 'nodeRunStateList',
              type: 'checkboxGroup',
              dataKey: 'nodeRunStateList',
              componentProps: {
                options: this.nodeRunStateList.map(e => ({
                  label: e.text,
                  value: e.state,
                  indeterminate: ({ value }, { nodeList }) => {
                    const list = this.nodeListStateGroup[value].items;

                    const len = list.filter(e => nodeList.includes(e.id)).length;

                    return len > 0 && len < list.length;
                  }
                }))
              }
            }
          ]
        },
        {
          id: 'nodeSelection',
          name: '节点名称',
          icon: 'icon-select-node',
          show: () => this.mode !== 'review',
          subPanelStyle: {
            '--sub-panel-width': '15vw'
          },
          options: [
            {
              prop: 'nodeListCheckAll',
              type: 'checkbox',
              on: {
                change: v => {
                  if (v) {
                    this.form.model.nodeList.splice(0, Infinity, ...this.nodeList.map(e => e.id));
                  } else {
                    this.form.model.nodeList.splice(0, Infinity);
                  }
                }
              },
              componentProps: {
                label: '全选',
                indeterminate: ({ nodeList }) => {
                  return nodeList.length > 0 && nodeList.length < this.nodeList.length;
                }
              }
            },
            {
              prop: 'nodeList',
              type: 'checkboxGroup',
              dataKey: 'nodeList',
              componentProps: {
                props: {
                  label: 'name',
                  value: 'id'
                }
              }
            }
          ]
        },
        {
          id: 'pathogenSelection',
          name: '病原体',
          icon: 'icon-pathogen',
          show: () => this.mode !== 'review',
          subPanelStyle: {},
          options: [
            {
              prop: 'pathogenListCheckAll',
              type: 'checkbox',
              on: {
                change: v => {
                  if (v) {
                    this.form.model.pathogenList.splice(
                      0,
                      Infinity,
                      ...this.pathogenList.map(e => e.pathogenType)
                    );
                  } else {
                    this.form.model.pathogenList.splice(0, Infinity);
                  }
                }
              },
              componentProps: {
                label: '全选',
                indeterminate: ({ pathogenList }) => {
                  return pathogenList.length > 0 && pathogenList.length < this.pathogenList.length;
                }
              }
            },
            {
              prop: 'pathogenList',
              type: 'checkboxGroup',
              dataKey: 'pathogenList',
              componentProps: {
                props: {
                  label: 'pathogenTypeName',
                  value: 'pathogenType'
                }
              }
            }
          ]
        }
      ]
    };
  },
  computed: {
    isInitialized() {
      return this.isInitializedGetter();
    }
  },
  methods: {},
  watch: {},
  async mounted() {
    this.selectAll();
  }
};
</script>

<style lang="scss">
.history-review-container {
  width: 100%;
  height: 100%;

  overflow: hidden;

  background: url('/static/image/rteao-monitor/background.png') 0 0 / 100% 100% no-repeat;

  .m-card {
    width: calc(100% - 200px);
    height: calc(100% - 140px);
    margin: 100px auto 0;
  }

  .review-options {
    width: 76%;
    height: 100%;
    margin: auto;

    box-sizing: border-box;

    // overflow: auto;
    // @include scrollar-style-thin;

    // border: 1px solid #0f80cb;
    // border-radius: 10px;
    // background: rgba(4, 9, 16, 0.3);
    // backdrop-filter: blur(2px);

    display: grid;
    grid: auto-flow dense / 1fr 1fr 1fr 1fr;
    // justify-content: center;
    gap: 20px;
    padding: 20px;

    position: relative;

    &-item:nth-of-type(1) {
      grid-column: auto / span 3;
      grid-row: auto / span 1;

      display: flex;
      gap: 20px;
      height: 100%;
      overflow: unset;
    }

    .handle-button {
      grid-column: auto / span 1;
      grid-row: auto / span 1;

      // position: absolute;
      // left: 50%;
      // bottom: 20px;
      // transform: translateX(-50%);

      .el-button {
        font-size: 1rem;
        width: 6.5rem;
      }
    }

    &-item {
      grid-column: auto / span 1;
      grid-row: auto / span 9;

      height: 100%;
      overflow: hidden;

      &_title {
        font-size: 1.4rem;

        margin-bottom: 0.5rem;

        display: inline-block;
      }

      &_content {
        height: calc(100% - 45px);

        .el-form {
          height: 100%;
          overflow: auto;
          @include scrollar-style-thin;
        }
      }
    }

    .el-form {
      &-item {
        margin-bottom: 5px;

        .el-date-editor {
          height: 2rem;
          line-height: 2rem;

          .el-range__icon {
            font-size: 0.8rem;
          }

          .el-range-input {
            font-size: 1rem;
          }

          .el-month-table {
            font-size: 0.8rem;
          }

          .el-date-range-picker__header {
            .el-picker-panel__icon-btn {
              font-size: 0.8rem;
            }

            div {
              font-size: 1rem;
            }
          }
        }

        .el-radio-group {
          display: flex;
          flex-direction: column;
          gap: var(--gap);
          // padding: 1.3vw 1vw;

          .el-radio {
            height: 2rem;
            line-height: 2rem;
            font-size: 1.35rem;

            &__label {
              font-size: 1.35rem;
            }

            .el-radio__inner {
              width: 1.25rem;
              height: 1.25rem;

              &::after {
                width: 0.4rem;
                height: 0.4rem;
              }
            }
          }
        }

        .el-checkbox {
          height: 2rem;
          line-height: 2rem;
          font-size: 1.35rem;

          &__label {
            font-size: 1.35rem;
          }

          .el-checkbox__inner {
            width: 1.25rem;
            height: 1.25rem;
            border: 1px solid #078ca3;

            &::before {
              top: 48%;
            }

            &::after {
              left: 32%;
              top: 15%;
              width: 0.26rem;
              height: 0.5rem;

              border: 3px solid #0c1620;
              border-left: 0;
              border-top: 0;
            }
          }
        }

        .el-checkbox-group {
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          // height: 500px;
        }
      }
    }
  }
}
</style>
